<div class="container">
    <div class="grid">
        <div class="col-lg-7 col-md-12 col-sm-12">
            <div class="form-body">
                <div class="text-center bg-red p-4 form-head">
                    <img class="img-fluid" src="../../assets/logo-login.png">
                </div>
                <div class="p-5 bg-twhite">
                    <mat-horizontal-stepper linear="true" #stepper>
                        <mat-step [stepControl]="detailForm" [editable]="false">
                            <form [formGroup]="detailForm">
                                <mat-form-field appearance="fill" class="input-group">
                                    <mat-label>First name</mat-label>
                                    <input matInput placeholder="First Name" formControlName="FirstName" autocomplete="off" required>
                                    <div class="error-indicator" *ngIf="detailForm.controls.FirstName.errors && (detailForm.controls.FirstName.dirty || detailForm.controls.FirstName.touched)">
                                      <p *ngIf="detailForm.controls.FirstName.errors.required">First Name is required</p>
                                    </div>
                                  </mat-form-field>
                                  <mat-form-field appearance="fill" class="input-group">
                                      <mat-label>Last name</mat-label>
                                      <input matInput placeholder="Last Name" formControlName="LastName" autocomplete="off" required>
                                      <div class="error-indicator" *ngIf="detailForm.controls.LastName.errors && (detailForm.controls.LastName.dirty || detailForm.controls.LastName.touched)">
                                        <p *ngIf="detailForm.controls.LastName.errors.required">Last Name is required</p>
                                      </div>
                                  </mat-form-field>
                                  <mat-form-field appearance="fill" class="input-group">
                                      <mat-label>Gender</mat-label>
                                      <mat-select formControlName="Gender" autocomplete="off" required>
                                        <mat-option *ngFor="let sex of genderList" [value]="sex.value">
                                          {{sex.label}}
                                        </mat-option>
                                      </mat-select>
                                      <div class="error-indicator" *ngIf="detailForm.controls.Gender.errors && (detailForm.controls.Gender.dirty || detailForm.controls.Gender.touched)">
                                        <p *ngIf="detailForm.controls.Gender.errors.required">Gender is required</p>
                                      </div>
                                    </mat-form-field>
                                  <mat-form-field appearance="fill" class="input-group">
                                      <mat-label>Email</mat-label>
                                      <input type="email" matInput placeholder="example@gmail.com" formControlName="Email" autocomplete="off" required>
                                      <div class="error-indicator" *ngIf="detailForm.controls.Email.errors && (detailForm.controls.Email.dirty || detailForm.controls.Email.touched)">
                                        <p *ngIf="detailForm.controls.Email.errors.required">Email is required</p>
                                        <p *ngIf="detailForm.controls.Email.errors.email">Email is invalid</p>
                                      </div>
                                  </mat-form-field>
                                  <mat-form-field appearance="fill" class="input-group">
                                      <mat-label>Mobile Number</mat-label>
                                      <input matInput placeholder="Mobile Number" formControlName="MobileNo" autocomplete="off" required>
                                      <div class="error-indicator" *ngIf="detailForm.controls.MobileNo.errors && (detailForm.controls.MobileNo.dirty || detailForm.controls.MobileNo.touched)">
                                        <p *ngIf="detailForm.controls.MobileNo.errors.required">Mobile Number is required</p>
                                      </div>
                                  </mat-form-field>
                                  <mat-form-field appearance="fill" class="input-group">
                                      <mat-label>Legal ID</mat-label>
                                      <input matInput placeholder="Legal ID" formControlName="LegalId" autocomplete="off">
                                      <div class="error-indicator" *ngIf="detailForm.controls.LegalId.errors && (detailForm.controls.LegalId.dirty || detailForm.controls.LegalId.touched)">
                                        <p *ngIf="detailForm.controls.LegalId.errors.required">Legal ID is required</p>
                                      </div>
                                  </mat-form-field>
                                  <mat-form-field appearance="fill" class="input-group mb-2">
                                    <mat-label>Birth Date</mat-label>
                                    <input matInput [matDatepicker]="picker" formControlName="DateOfBirth" [max]="maxDate" (dateChange)="onDateChange($event)"  autocomplete="off" required>
                                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                    <div class="age-error-indicator" *ngIf="minDateError">
                                        <span>Minimum age should be {{minAge}} years</span>
                                    </div>
                                    <div class="error-indicator" *ngIf="detailForm.controls.DateOfBirth.errors && (detailForm.controls.DateOfBirth.dirty || detailForm.controls.DateOfBirth.touched)">
                                      <p *ngIf="detailForm.controls.DateOfBirth.errors.required">Date Of Birth is required</p>
                                    </div>
                                  </mat-form-field>
                                  <mat-form-field appearance="fill" class="input-group">
                                      <mat-label>Nationality</mat-label>
                                      <mat-select formControlName="NationalityId" autocomplete="off" required>
                                        <mat-option *ngFor="let nation of dropDownValues['CountryList']" [value]="nation.value">
                                          {{nation.label}}
                                        </mat-option>
                                      </mat-select>
                                      <div class="error-indicator" *ngIf="detailForm.controls.NationalityId.errors && (detailForm.controls.NationalityId.dirty || detailForm.controls.NationalityId.touched)">
                                        <p *ngIf="detailForm.controls.NationalityId.errors.required">Nationality is required</p>
                                      </div>
                                  </mat-form-field>
                                  <mat-form-field appearance="fill" class="input-group">
                                      <mat-label>Club Location</mat-label>
                                      <mat-select formControlName="LocationId" autocomplete="off" required>
                                        <mat-option *ngFor="let club of dropDownValues['LocationList']" [value]="club.value">
                                          {{club.label}}
                                        </mat-option>
                                      </mat-select>
                                      <div class="error-indicator" *ngIf="detailForm.controls.LocationId.errors && (detailForm.controls.LocationId.dirty || detailForm.controls.LocationId.touched)">
                                        <p *ngIf="detailForm.controls.LocationId.errors.required">Club is required</p>
                                      </div>
                                  </mat-form-field>
                                  <div class="footer">
                                    <button mat-button matStepperNext (click)="AddCustomer()" [disabled]="detailForm.invalid || minDateError">Next</button>
                                  </div>
                            </form>
                        </mat-step>
                        <mat-step editable="false">
                            <h4>Selected Club Location: <span class="text-danger">{{LocationName}}</span></h4>
                            <div class="mt-3">
                              <h4>Select Membership Plan</h4>
                            </div>
                            <div class="row">
                              <div class="col-12" *ngFor="let item of itemList">
                                <div class="p-3 border rounded bg-light">
                                  <h4>{{item.ItemDescription}}</h4>
                                  <div class="row">
                                    <div class="col-lg-8 col-md-12 col-sm-12">
                                      <div class="row">
                                        <div class="col-6">
                                          <p>Price</p>
                                        </div>
                                        <div class="col-6 text-right">
                                          {{item.Price}}
                                        </div>
                                        <div class="col-6">
                                          <p>Plan Duration</p>
                                        </div>
                                        <div class="col-6 text-right">
                                          {{item.PlanDuration}}
                                        </div>
                                        <div class="col-6">
                                          <p>Plan Payment Type</p>
                                        </div>
                                        <div class="col-6 text-right">
                                          {{item.PlanPaymentTypeName}}
                                        </div>
                                        <div class="col-6">
                                          <p>Plan Tier</p>
                                        </div>
                                        <div class="col-6 text-right">
                                          {{item.PlanTierName}}
                                        </div>
                                      </div>
                                    </div>
                                    
                                    <div class="col-lg-4 col-md-12 col-sm-12">
                                      <p class="m-0">
                                        <button class="pull-right select" mat-raised-button color="black" (click)="itemSelect(item)">Select</button>
                                      </p>
                                    </div>
                                  </div>
                                  <!-- <p class="m-0">
                                    <button class="pull-right select" mat-raised-button color="black" (click)="itemSelect(item)">Select</button>
                                  </p>
                                  <table>
                                    <tbody>
                                      <tr>
                                        <td class="itemSlabCell">Price</td>
                                        <td>{{item.Price}}</td>
                                      </tr>
                                      <tr>
                                        <td class="itemSlabCell">Plan Duration</td>
                                        <td>{{item.PlanDuration}}</td>
                                      </tr>
                                      <tr>
                                        <td class="itemSlabCell">Plan Pyment Type</td>
                                        <td>{{item.PlanPaymentTypeName}}</td>
                                      </tr>
                                      <tr>
                                        <td class="itemSlabCell">Plan Tier</td>
                                        <td>{{item.PlanTierName}}</td>
                                      </tr>
                                    </tbody>
                                  </table> -->
                                </div>
                              </div>
                            </div>
                        </mat-step>
                        <mat-step editable="false">
                            <h5>
                              <table *ngIf="itemDetail != null">
                                <tbody>
                                  <tr>
                                    <td class="td-heading">Plan</td>
                                    <td class="td-value">{{itemDetail.ItemDescription}}</td>
                                  </tr>
                                  <tr>
                                    <td class="td-heading">Price</td>
                                    <td class="td-value">{{itemDetail.Price}}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </h5>
                            <p class="alert alert-warning mt-4">You will now be redirected to our bank payment page, please confirm credit card information for security and payment purposes.</p>
                            <hr>

                            <div class="row">
                              <div class="col-lg-9 col-md-9 col-sm-12 mb-5">
                                <mat-checkbox color="primary" [(ngModel)]="checked"></mat-checkbox>
                                    &nbsp;&nbsp;<a class="txt-decor terms" target="_blank" (click)="goToTerms()">I agree to Terms & Conditions</a>
                              </div>
                              <div class="col-lg-3 col-md-3 col-sm-12 text-right">
                                <button mat-raised-button color="warn" (click)="payNow()" [disabled]="!checked">Pay Now</button>
                              </div>
                            </div>
                            <!-- <table class="width100">
                              <tbody>
                                <tr>
                                  <td>
                                    <mat-checkbox color="primary" [(ngModel)]="checked"></mat-checkbox>
                                    &nbsp;&nbsp;<a class="txt-decor terms" target="_blank" (click)="goToTerms()">I agree to Terms & Conditions</a>
                                  </td>
                                  <td class="text-right">
                                    <button mat-raised-button color="warn" (click)="payNow()" [disabled]="!checked">Pay Now</button>
                                  </td>
                                </tr>
                              </tbody>
                            </table> -->
                          </mat-step>
                    </mat-horizontal-stepper>
                    <!-- <mat-stepper
                    class="example-stepper"
                    [orientation]="(stepperOrientation | async)!" linear="true">
                    <mat-step [stepControl]="detailForm" editable="false">
                      <form [formGroup]="detailForm">
                        <mat-form-field appearance="fill" class="input-group">
                          <mat-label>First name</mat-label>
                          <input matInput placeholder="First Name" formControlName="FirstName" autocomplete="off" required>
                        
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="input-group">
                            <mat-label>Last name</mat-label>
                            <input matInput placeholder="Last Name" formControlName="LastName" autocomplete="off" required>
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="input-group">
                            <mat-label>Gender</mat-label>
                            <mat-select formControlName="Gender" autocomplete="off" required>
                              <mat-option *ngFor="let sex of genderList" [value]="sex.value">
                                {{sex.label}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        <mat-form-field appearance="fill" class="input-group">
                            <mat-label>Email</mat-label>
                            <input type="email" matInput placeholder="Email" formControlName="Email" autocomplete="off" required>
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="input-group">
                            <mat-label>Mobile Number</mat-label>
                            <input matInput placeholder="Mobile Number" formControlName="MobileNo" autocomplete="off" required>
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="input-group">
                            <mat-label>Legal ID</mat-label>
                            <input matInput placeholder="Legal ID" formControlName="LegalId" autocomplete="off" required>
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="input-group">
                          <mat-label>Birth Date</mat-label>
                          <input matInput [matDatepicker]="picker" formControlName="DateOfBirth" autocomplete="off" required>
                          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="input-group">
                            <mat-label>Nationality</mat-label>
                            <mat-select formControlName="NationalityId" autocomplete="off" required>
                              <mat-option *ngFor="let nation of dropDownValues['CountryList']" [value]="nation.value">
                                {{nation.label}}
                              </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="input-group">
                            <mat-label>Club Location</mat-label>
                            <mat-select formControlName="LocationId" autocomplete="off" required>
                              <mat-option *ngFor="let club of dropDownValues['LocationList']" [value]="club.value">
                                {{club.label}}
                              </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="footer">
                          <button mat-button matStepperNext (click)="AddCustomer()">Next</button>
                        </div>
                      </form>
                    </mat-step>
                    <mat-step editable="false">
                      <h4>Selected Club Location: <span class="text-danger">{{LocationName}}</span></h4>
                      <div class="mt-3">
                        <h4>Select Membership Plan</h4>
                      </div>
                      <div class="row">
                        <div class="col-12" *ngFor="let item of itemList">
                          <div class="p-3 border rounded bg-light">
                            <h4>{{item.ItemDescription}}</h4>
                            <p class="m-0">
                              <button class="pull-right select" mat-raised-button color="black" matStepperNext (click)="itemSelect(item)">Select</button>
                            </p>
                            <table>
                              <tbody>
                                <tr>
                                  <td class="itemSlabCell">Price</td>
                                  <td>{{item.Price}}</td>
                                </tr>
                                <tr>
                                  <td class="itemSlabCell">Plan Duration</td>
                                  <td>{{item.PlanDuration}}</td>
                                </tr>
                                <tr>
                                  <td class="itemSlabCell">Plan Pyment Type</td>
                                  <td>{{item.PlanPaymentTypeName}}</td>
                                </tr>
                                <tr>
                                  <td class="itemSlabCell">Plan Tier</td>
                                  <td>{{item.PlanTierName}}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </mat-step>
                    <mat-step editable="false">
                      <h5>
                        <table *ngIf="itemDetail != null">
                          <tbody>
                            <tr>
                              <td class="td-heading">Plan</td>
                              <td class="td-value">{{itemDetail.ItemDescription}}</td>
                            </tr>
                            <tr>
                              <td class="td-heading">Price</td>
                              <td class="td-value">{{itemDetail.Price}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </h5>
                      <p class="alert alert-warning mt-4">You will now be redirected to our bank payment page, please confirm credit card information for security and payment purposes.</p>
                      <hr>
                      <table class="width100">
                        <tbody>
                          <tr>
                            <td>
                              <mat-checkbox [(ngModel)]="checked"></mat-checkbox>
                              <a href="" class="txt-decor terms" target="_blank">I agree to Terms & Conditions</a>
                            </td>
                            <td class="text-right">
                              <button mat-raised-button color="warn" (click)="payNow()" [disabled]="!checked">Pay Now</button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </mat-step>
                  </mat-stepper> -->
                </div>
            </div>
        </div>
    </div>
</div>